import React from "react";
import { VMBuilder } from "../../../../commons/base/providers/builder";
import WasteAdjustmentViewModel from "../view_models/waste_adjustment_view_model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import QtyInput from "../../commons/ui/qty_input";
import Select from "react-select";

export default class WasteAdjustmentModalWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<WasteAdjustmentViewModel>>
                {(vm) => (
                    <div
                        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 pt-4 px-4"
                        onClick={() => vm.resetForm()}
                    >
                        {/* Title & Search Bar */}
                        <div
                            className="flex flex-col bg-white rounded-lg shadow-lg w-full max-w-6xl h-[85vh] overflow-y-auto relative"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="sticky top-0 bg-white px-6 py-3 shadow-sm">
                                <h2 className="text-2xl font-bold">
                                    Adjust Waste
                                </h2>

                                <div className="relative">
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        className="w-full border border-gray-300 rounded-lg my-2 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        onChange={(e) => {
                                            const query =
                                                e.target.value.toLowerCase();
                                            vm.updateSearchQuery(query);
                                        }}
                                    />
                                    <FontAwesomeIcon
                                        icon={faSearch}
                                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                                    />
                                </div>
                            </div>

                            {/* Mapping data */}
                            <div className="flex-grow space-y-4 px-6 mt-3">
                                {vm.filteredItemQtyModels.map((item) => (
                                    <div
                                        key={item.masterItemId}
                                        className={`grid grid-cols-10 gap-4 items-center border-b p-2 ${
                                            vm.formItemsMap.get(
                                                item.masterItemId
                                            )?.isUpdated
                                                ? "bg-yellow-300"
                                                : ""
                                        }`}
                                    >
                                        {/* Item Name */}
                                        <span className="col-span-2 text-gray-700 font-semibold">
                                            {vm.masterItemMap.get(
                                                item.masterItemId
                                            )?.name ?? ""}
                                        </span>

                                        {/* Big Qty */}
                                        <div className="col-span-2">
                                            <QtyInput
                                                label={
                                                    vm.masterItemMap.get(
                                                        item.masterItemId
                                                    )?.bigUnit ?? "N/A"
                                                }
                                                model={
                                                    vm.formItemsMap.get(
                                                        item.masterItemId
                                                    )!
                                                }
                                                field="qtyBigUnit"
                                                onChange={(e) =>
                                                    vm.updateItemQtyModel(
                                                        item.masterItemId,
                                                        "qtyBigUnit",
                                                        Number(e.target.value)
                                                    )
                                                }
                                            />
                                        </div>

                                        {/* Small Qty */}
                                        <div className="col-span-2">
                                            <QtyInput
                                                label={
                                                    vm.masterItemMap.get(
                                                        item.masterItemId
                                                    )?.smallUnit ?? "N/A"
                                                }
                                                model={
                                                    vm.formItemsMap.get(
                                                        item.masterItemId
                                                    )!
                                                }
                                                field="qtySmallUnit"
                                                onChange={(e) =>
                                                    vm.updateItemQtyModel(
                                                        item.masterItemId,
                                                        "qtySmallUnit",
                                                        Number(e.target.value)
                                                    )
                                                }
                                            />
                                        </div>

                                        {/* Waste Type */}
                                        <div className="col-span-2">
                                            <label className="block text-sm text-gray-400">
                                                Tipe Waste
                                            </label>
                                            <select
                                                value={item.wasteType}
                                                className="w-full border rounded-lg px-3 py-2 mt-1"
                                                onChange={(e) => {
                                                    vm.updateItemQtyModel(
                                                        item.masterItemId,
                                                        "wasteType",
                                                        e.target.value
                                                    );
                                                }}
                                            >
                                                <option
                                                    value=""
                                                    disabled
                                                    key={999}
                                                >
                                                    Select Waste Type
                                                </option>
                                                {vm.wasteTypes.map(
                                                    (wasteType) => (
                                                        <option
                                                            key={`waste-type-${wasteType.id}`}
                                                            value={
                                                                wasteType.name
                                                            }
                                                        >
                                                            {wasteType.name}
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        </div>

                                        {/* Note */}
                                        <div className="col-span-2">
                                            <label className="block text-sm text-gray-400">
                                                Keterangan
                                            </label>
                                            <input
                                                type="text"
                                                className="w-full border rounded-lg px-3 py-2 mt-1"
                                                placeholder="Keterangan"
                                                value={item.note}
                                                onChange={(e) => {
                                                    vm.updateItemQtyModel(
                                                        item.masterItemId,
                                                        "note",
                                                        e.target.value
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Select Item & Add Btn */}
                            <div className="mt-6 sticky bottom-0 bg-white px-4 py-6 shadow-inner">
                                <div className="w-full flex space-x-4 items-center">
                                    <div className="flex-grow">
                                        <Select
                                            className="basic-single w-full"
                                            classNamePrefix="select"
                                            isClearable={true}
                                            isSearchable={true}
                                            name="item"
                                            options={vm.shownItemOptions.map(
                                                (option) => ({
                                                    value: option.id,
                                                    label: option.name,
                                                })
                                            )}
                                            onChange={(selectedOption) => {
                                                if (selectedOption?.value) {
                                                    vm.updateSelectedItemId(
                                                        selectedOption?.value
                                                    );
                                                }
                                            }}
                                            placeholder="Tambah Item ?"
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                            }}
                                        />
                                    </div>

                                    {/* Add Btn */}
                                    <button
                                        onClick={() => {
                                            if (vm.selectedItemId) {
                                                vm.addItemQtyModel(
                                                    vm.selectedItemId
                                                );
                                            }
                                        }}
                                        disabled={!vm.selectedItemId}
                                        className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 disabled:bg-gray-500"
                                    >
                                        Masukkan
                                    </button>
                                </div>
                                {/* Submit Btn */}
                                <div className="mt-4">
                                    <button
                                        onClick={() =>
                                            vm.submitWasteAdjustment()
                                        }
                                        className="w-full bg-green-500 text-white px-4 py-3 rounded-lg hover:bg-green-600 disabled:bg-gray-500"
                                        disabled={!vm.isAbleToSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
